import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'
import { Stripe } from '@stripe/stripe-js/types/stripe-js'

@Component({
  computed: {
    ...mapState('app', ['app'])
  }
})
export default class StripeMixin extends Vue {
  app!: KwixeoFramework.App

  protected stripe: Stripe|null = null

  // Initialize Stripe
  protected async initializeStripe (): Promise<void> {
    const key = this.app.stripe_public_key
    if (!key) {
      return
    }

    const stripe = await loadStripe(key)
    if (!stripe) {
      return
    }

    this.stripe = stripe
  }
}
